type OrderDataRowProps = {
  title: React.ReactNode;
  value: React.ReactNode;
  tone?: 'default' | 'error';
};

const OrderDataRow: React.FC<OrderDataRowProps> = ({title, value, tone = 'default'}) => {
  return (
    <div className="flex min-h-11 items-center justify-between gap-3 border-b border-gray-03 px-2.5 py-2 text-body-md-emphasis last:border-0">
      <span className="text-gray-07">{title}</span>
      <span className={tone === 'error' ? 'text-destructive' : 'text-gray-09'}>{value}</span>
    </div>
  );
};

export default OrderDataRow;
